// What serves a custom endpoint, for its logo. Pure, so it can be unit tested
// without the SVG imports in vendor-logos.ts.

export const ENDPOINT_KINDS = [
  "azure",
  "bedrock",
  "vertex",
  "openai",
  "mistral",
  "openrouter",
  "together",
  "groq",
  "fireworks",
  "huggingface",
  "nvidia",
  "ollama",
  "vllm",
  "lmstudio",
] as const;

export type EndpointKind = (typeof ENDPOINT_KINDS)[number];

// Hosted services by their hostname. Regional hosts: Bedrock
// "bedrock-runtime.us-east-1.amazonaws.com", Vertex
// "us-central1-aiplatform.googleapis.com".
const HOSTS: Array<[RegExp, EndpointKind]> = [
  [/(^|\.)openrouter\.ai$/, "openrouter"],
  [/(^|\.)(openai\.azure\.com|services\.ai\.azure\.com)$/, "azure"],
  [/(^|\.)bedrock[a-z0-9-]*\.[a-z0-9-]+\.(amazonaws\.com|api\.aws)$/, "bedrock"],
  [/(^|[.-])aiplatform\.googleapis\.com$/, "vertex"],
  [/^api\.openai\.com$/, "openai"],
  [/^api\.mistral\.ai$/, "mistral"],
  [/(^|\.)together\.(xyz|ai)$/, "together"],
  [/^api\.groq\.com$/, "groq"],
  [/(^|\.)fireworks\.ai$/, "fireworks"],
  [/(^|\.)huggingface\.co$/, "huggingface"],
  [/(^|\.)api\.nvidia\.com$/, "nvidia"],
];

// From the address, else from the ID ("ollama", "lmstudio-2"): a tunnel
// address says nothing.
export function endpointKind(baseUrl: string | undefined, name?: string): EndpointKind | null {
  const fromName = (): EndpointKind | null => {
    // A list lookup, not `in`: "constructor" is a valid ID.
    const base = name?.replace(/-\d+$/, "") as EndpointKind | undefined;
    return base && ENDPOINT_KINDS.includes(base) ? base : null;
  };
  if (!baseUrl) return fromName();
  try {
    const u = new URL(baseUrl);
    const host = u.hostname.toLowerCase();
    const hosted = HOSTS.find(([re]) => re.test(host));
    if (hosted) return hosted[1];
    if (u.port === "11434" || host.includes("ollama")) return "ollama";
    if (u.port === "1234" || host.includes("lmstudio")) return "lmstudio";
    if (host.includes("vllm")) return "vllm";
  } catch {
    /* not a URL */
  }
  return fromName();
}
